export default function MailIcon(props) {
  return (
    <svg
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M1.66699 5.83398L8.47109 10.5969C9.02207 10.9825 9.29756 11.1754 9.59721 11.2501C9.8619 11.3161 10.1387 11.3161 10.4034 11.2501C10.7031 11.1754 10.9786 10.9825 11.5296 10.5969L18.3337 5.83398M5.66699 16.6673H14.3337C15.7338 16.6673 16.4339 16.6673 16.9686 16.3948C17.439 16.1552 17.8215 15.7727 18.0612 15.3023C18.3337 14.7675 18.3337 14.0674 18.3337 12.6673V7.33398C18.3337 5.93385 18.3337 5.23379 18.0612 4.69901C17.8215 4.2286 17.439 3.84615 16.9686 3.60647C16.4339 3.33398 15.7338 3.33398 14.3337 3.33398H5.66699C4.26686 3.33398 3.5668 3.33398 3.03202 3.60647C2.56161 3.84615 2.17916 4.2286 1.93948 4.69901C1.66699 5.23379 1.66699 5.93385 1.66699 7.33398V12.6673C1.66699 14.0674 1.66699 14.7675 1.93948 15.3023C2.17916 15.7727 2.56161 16.1552 3.03202 16.3948C3.5668 16.6673 4.26686 16.6673 5.66699 16.6673Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
